let newSlide = document.querySelector('.b-mini_cart-popover');
let openedSlider = document.querySelector(".h-hamburger");
let navv = document.querySelector('.h-hamburger-navigation_content');
var size = window.matchMedia("(max-width: 700px)");
let addVariants = document.getElementById("b-show-more");
let showMoreSwatch = document.querySelector(".b-swatch_colors-wrapper");
var maccor= "m-accordion-expanded"
let backToTop = document.querySelector("#backTop");
let overlayBg = document.getElementById("bg_dark");

let myScrollFunc = function () {
  let y = window.scrollY;
  if (y >= 100) {
    backToTop.className = "b-button_back_to_top m-active";
    $('#headerSection').addClass('m-sticky');
    $('.b-header-promo ').addClass('d-none');
    $('.b-hero_slider').addClass('d-none');
    $('#MainContent').addClass('mt-10');
  } else {
    backToTop.className = "b-button_back_to_top m-deactive";
    $('#headerSection').removeClass('m-sticky');
    $('.b-header-promo ').removeClass('d-none');
    $('.b-hero_slider').removeClass('d-none');
    $('#MainContent').removeClass('mt-10');
  }
};
let bgLoader = document.querySelector(".bg-loader");
window.addEventListener("scroll", myScrollFunc);

  //Mini-cart-Slider
  function cartSlide() {
    $('.b-mini_cart-container').load(location.href + " .b-mini_cart-container");
    if(!newSlide.classList.contains('show_Slider')){
       newSlide.className += " show_Slider" ;
       $('#bg_dark').addClass('cartOverlay');
      }else{ 
        newSlide.classList.remove("show_Slider");
        $('#bg_dark').removeClass('cartOverlay');
      }
  };
  const closeSlider = () =>{
    overlayBg.classList.remove("overlay", "newOverlay", "cartOverlay");
    if(openedSlider.classList.contains('m-hamburger_opened')){
      openedSlider.classList.remove("m-hamburger_opened");
    }
    if(newSlide.classList.contains('show_Slider')){
      newSlide.classList.remove("show_Slider");
     }
     if(document.getElementById('headerSection').classList.contains('m-search_opened')){
      $('#headerSection').removeClass("m-search_opened");
     }
    if( window.location.href.toString().includes('collections') || window.location.href.toString().includes('search?q=')){
      if(document.getElementById('main-filter').classList.contains('m-refinements')){
      $('#main-filter').removeClass('m-refinements');
     }
    }
  }
  //addto cart reuse Func
 const reUseCart = async (method, varId , qty) =>{
  $('.bg-loader').removeClass('d-none');
  await axios
      .post(method, {
        id: varId,
        quantity: qty ? qty : 1 ,
      })
      .then((res) => {
        $('.b-mini_cart-container').load(location.href + " .b-mini_cart-container");
        $('.cartIconQty').load(location.href + " .cartIconQty");
        cartSlide();
        setTimeout(() => {
          $('.bg-loader').addClass('d-none');
        }, 0);
      }).catch((error) => {
        console.error('Error:', error);
      });
 }

  //change to currency function 
  function changeToCurrency(amount) {
    let currencyAmt = Number((amount) / 100).toLocaleString(undefined, { minimumFractionDigits: 2 });
    return currencyAmt;
  }

  //Minicart Item remover
  function removeItem(varId) {
    $('.bg-loader').removeClass('d-none');
    $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        dataType: 'json',
        data: {
            'id': parseFloat(varId),
            'quantity': 0
        }
    }).then(res => {
        setTimeout(() => {
            $('.bg-loader').addClass('d-none');
        }, 800);
        $('.b-mini_cart-container').load(location.href + " .b-mini_cart-container");
        $('.cartIconQty').load(location.href + " .cartIconQty");
    })
  }

// Quantity Selector Button
$('.qtybox .btnqty').on('click', function () {
  var qty = parseInt($(this).parent('.qtybox').find('.quantity-input').val());
  var inventoryQty = parseInt($(this).parent('.qtybox').find('.quantity-input').attr('inventory'));
  if ($(this).hasClass('qtyplus')) {
   qty == inventoryQty ?  $('.b-qty_selector-error').show('fast'): qty++;
  } else {
    if (qty > 1) {
      qty == inventoryQty ?  $('.b-qty_selector-error').hide('fast'): false;
      qty--;
    }
  } qty = (isNaN(qty)) ? 1 : qty;
  $(this).parent('.qtybox').find('.quantity-input').val(qty);
  $('.quantity-input').attr("value", qty);
});

//No reload During form submittion
const onSubmit= (e)=>{
  e.preventDefault();
}

//add to Cart for collection Page
  var productFirstVariant = document.querySelectorAll(".b-add_to_bagId");
  const addtocart = async(index,e) => {
    e.preventDefault();
    let prokey = productFirstVariant[index].value;
    reUseCart("/cart/add.js" , prokey , 1 );
  };

  // add to Bag for Product page
  const addToBag = async () =>{
    let productKey =$('#b-add_to_bag-button').attr('product_variantId');
    let quant =$('.quantity-input').val();
    reUseCart("/cart/add.js" , productKey , quant );
  }

//for WishList
  function getIndex(proId) {
     var nonWishBtn = document.querySelectorAll('.b-wishlist_button');
    if (JSON.parse(sessionStorage.getItem('wishlist')) == null || JSON.parse(sessionStorage.getItem('wishlist')) == undefined) {
      let wishArr = [];
      let newList = [
        ...wishArr,
        proId
      ]
      sessionStorage.setItem('wishlist', JSON.stringify(newList));
    } else {
      let checkIsWishlist = JSON.parse(sessionStorage.getItem('wishlist'));
      let presentWishIndex = checkIsWishlist.findIndex((obj) => obj.id == proId.id);
      if(presentWishIndex >= 0 ){
        window.location.href.toString().includes('collections') || window.location.href.toString().includes('search?q=') ? nonWishBtn[proId.index].classList.remove('m-active'): $('#wishlistbutton').removeClass('m-active');
        checkIsWishlist.length == 1 ? $('.b-wishlist_link-inner').removeClass('m-active'): false;
        return removeWishList(presentWishIndex);
      };
      
      let newList = [ ...JSON.parse(sessionStorage.getItem('wishlist')), proId];
      const uniqueArray = newList.filter((value, index) => { // removing Duplicate list
        const _value = JSON.stringify(value);
        return index === newList.findIndex(obj => {
          return JSON.stringify(obj) === _value;
        });
      });
      sessionStorage.setItem('wishlist', JSON.stringify(uniqueArray));
    }  $('.bg-loader').removeClass('d-none');
    setTimeout(() => {
      $('.bg-loader').addClass('d-none');
    }, 600);
    $('.b-wishlist_link-inner').addClass('m-active');
    $('.wishlist-icon-nav').addClass('m-active');
    window.location.href.toString().includes('collections') || window.location.href.toString().includes('search?q=') ? nonWishBtn[proId.index].classList.add('m-active'): $('#wishlistbutton').addClass('m-active');
  }
 const openSlider = () =>{
    openedSlider.classList.add("m-hamburger_opened");
    $('#bg_dark').addClass('cartOverlay');
    navv.classList.remove('hideElem');
 }
 
 const navSearchBar = () => {
  
  if(!($("#headerSection").hasClass('m-search_opened'))){
    $('#headerSection').addClass("m-search_opened")
    if (size) {
      $('#bg_dark').addClass("overlay");
    }
     $('#Search').focus();
  }else{
    $('#headerSection').removeClass("m-search_opened")
    $('#bg_dark').removeClass("overlay");
    clearSearch();
  }
 }

 // Show More Product Swatches 
 function showMore() {
     if (addVariants.classList.contains("b-show-less")) {
        showMoreSwatch.classList.remove("gridNone");
        addVariants.textContent = 'Show More';
         return addVariants.classList.remove("b-show-less");
   }
     addVariants.classList.add("b-show-less");
     showMoreSwatch.classList.add("gridNone");
     addVariants.textContent = 'Show Less';
 } 

 // accordion main-cart page
 const showAccordion = (sectionRef, macc="m-accordion-expanded") => {
  if ( $(`#${sectionRef}1`).hasClass(macc) ) {
    $(`#${sectionRef}1`).removeClass(macc);
    $(`#${sectionRef}2`).removeClass(macc);
    return  $(`#${sectionRef}3`).removeClass(macc);
    } else {
      $(`#${sectionRef}1`).addClass(macc);
     $(`#${sectionRef}2`).addClass(macc);
    return  $(`#${sectionRef}3`).addClass(macc);
    }
}

  // Image Gallery carousel
 Fancybox.bind('[data-fancybox="gallery]',{
    caption: function (fancybox, carousel, slide) {
      return (
      `${slide.index + 1} / ${carousel.slides.length} <br />` + slide.caption
      );
    },
  });

  // filter Slider

  const filter =()=>{
   if($("#main-filter" ).hasClass( "m-refinements") ){
     $('#main-filter').removeClass('m-refinements');
     $('#bg_dark').removeClass('cartOverlay');
    } else{
     $('#main-filter').addClass('m-refinements');
     $('#bg_dark').addClass('cartOverlay');
   } 
  }

  let showAccor= document.querySelectorAll("#showAccor");
  let footAccorId= document.querySelectorAll("#footAccor");
   function footAccor(i){
     if( !showAccor[i].classList.contains(maccor)){
       footAccorId[i].classList.add(maccor);
     return showAccor[i].classList.add(maccor);
      }
    showAccor[i].classList.remove(maccor);  
     footAccorId[i].classList.remove(maccor);  
   }

  //wishlist Removal Section 
   const removeWishList = (index) => {
    $('.bg-loader').removeClass('d-none');
    let updatedArr = JSON.parse(sessionStorage.getItem('wishlist'));
    updatedArr.splice(index, 1);
    sessionStorage.setItem('wishlist', JSON.stringify(updatedArr));
    setTimeout(() => {
      $('.bg-loader').addClass('d-none');
    }, 200);
  }

  // Forgot password Popup Modal
  const forgotModal = () =>{
    $(".m-checkout_login" ).hasClass( "tingle-modal--visible" ) ? $('.m-checkout_login').removeClass('tingle-modal--visible'): $('.m-checkout_login').addClass('tingle-modal--visible');
  }
    



  